import { Card } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { activityDistanceKm } from '../../api/activities';
import { formatDate } from '../../utils/date';

function ActivityItem({ activity }) {
  const startedAt = activity.startDate || activity.start_date || activity.start_date_local;

  return (
    <Card className="activity-card">
      <h2>{activity.name || 'Hoạt động'}</h2>
      <p className="htv-muted">
        <ClockCircleOutlined /> {formatDate(startedAt, 'dd/mm/yy, h:MM:ss TT')}
      </p>
      <div className="htv-pill-row">
        <span className="htv-pill">{activity.type || 'Run'}</span>
        <span className="htv-pill">{activityDistanceKm(activity)} km</span>
        {activity.pace && <span className="htv-pill">{activity.pace} min/km</span>}
      </div>
    </Card>
  );
}

export default ActivityItem;
